import React, { useEffect, useState } from 'react'
import { getCheckout } from '../Redux/ActionCreator/CheckoutActionCreator'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import BuyerProfile from './Partial/BuyerProfile'
import Menubar from './Partial/Menubar'
import Stepper from './Partial/Stepper'

export default function OrderDetail() {
    let [order, setOrder] = useState({})
    let dispatch = useDispatch()
    let { _id } = useParams();

    let CheckoutStateData = useSelector(state => state.CheckoutStateData)

    useEffect(() => {
        (() => {
            dispatch(getCheckout())
            if (CheckoutStateData.length) {
                let data = CheckoutStateData.find((x) => x._id === _id)
                setOrder(data)
            }
            else
                setOrder({})
        })()

    }, [CheckoutStateData.length])
    return (
        <>
            <Menubar title="Order Tracking Page" />
            <div className="mx-md-5 mx-lg-5 mt-4">
                <p className='mx-3'><b>Order Id : #{order._id}</b></p>
                <div className="testimonial-item img-border-radius shadow-sm bg-white mx-3 pt-4">
                    <div className='row px-3'>
                        <div className='col-md-6'>
                            {
                                order.products?.map((item, index) => {
                                    return <div key={index} className="d-flex gap-4">
                                        <div>
                                            <div>
                                                <img src={`/${item.product?.pic}`} height={100} width="100%" alt="" />
                                            </div>
                                        </div>
                                        <div>
                                            <h6>{item.product?.name} <span className='border px-2 py-1 rounded' style={{ fontSize: "10px" }}>brand: {item.product?.brand?.name}</span></h6>
                                            <span>{item.product?.brand?.name}, {item.product?.color}, {item.product?.size}</span>,
                                            <p><strong>&#8377; {item.total}</strong></p>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                        <div className='col-md-6 mt-3'>
                            <Stepper orderId={order._id} />
                        </div>
                    </div>
                    <hr />
                    <div className="row gx-2 mx-1">
                        <div className="col-md-6 mb-3">
                            <BuyerProfile title="OrderDetail" />
                        </div>
                        <div className="col-md-6">
                            <div className="row  testimonial-item img-border-radius shadow-md bg-white mx-1 px-2 mb-2 py-2">
                                <div className='col-md-6'>
                                    <p className='extra'><strong>Payment Mode</strong> : {order.paymentMode}</p>
                                    <p className='extra'><strong>Payment State</strong> : {order.paymentStatus} {order.paymentStatus === "Pending" && order.paymentMode !== "Case on delivery" ? <button style={{ fontSize: "10px", color: 'blue', border: "1px solid blue", borderRadius: "3px", padding: "2px" }}><Link to={`/payment/${order?._id}`}>Pay Now</Link></button> : ""}</p>
                                    <p className='extra'><strong>Subtotal</strong> : &#8377;{order.subtotal}</p>
                                    <p className='extra'><strong>Date</strong> : {new Date(order.date).toLocaleString()}</p>
                                </div>
                                <div className='col-md-6'>
                                    <span><strong>Total Amount</strong> : &#8377; {order.total} </span>
                                    <p className='extra'>sponsered by Ministore</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


